// extracted by mini-css-extract-plugin
export default {"Column":"DisabledVet-Form-PDF-style_Column__bmDFQ"};